/*
 * Разделы меню облаков «cloud.ru» и «VK Cloud»: managed-сервисы облака в сети кластеров платформы — по
 * странице на сервис (cloud.ru: RDS PostgreSQL / MySQL, DCS Redis, DMS RabbitMQ; VK Cloud: Cloud Databases
 * PostgreSQL / MySQL / Redis) со своей кнопкой создания (шаблон managed-<kind> / vkcloud-<kind>: юнит
 * terragrunt в viva/clusters <облако>/<кластер>/datastores/…, сервис создаёт пайплайн кластера). Без
 * учётных данных облака на стенде (viva.cloudru.enabled / viva.vkcloud.enabled) раздела в меню нет,
 * страницы — «не подключён».
 */
import { Button, Typography } from '@material-ui/core';
import { Content, EmptyState, Header, Page } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { MANAGED_CLOUDS, ManagedService } from '../../lib/viva';
import { datastoreColumns } from './columns';
import { TypedCatalogPage } from './TypedCatalogPage';

const CloudDisabled = ({ service: s }: { service: ManagedService }) => {
  const cloud = MANAGED_CLOUDS[s.cloud];
  return (
    <Page themeId={s.cloud}>
      <Header title={`${s.title} (${cloud.short})`} />
      <Content>
        <EmptyState
          missing="info"
          title={`${cloud.title} не подключён`}
          description={`Managed-сервисы ${cloud.short} появляются, когда в .env стенда задан ${cloud.credentials} (DEPLOY_ENV поставщика) и стенд обновлён deploy:stand.`}
        />
      </Content>
    </Page>
  );
};

const ManagedServiceList = ({ service: s }: { service: ManagedService }) => {
  const cloud = MANAGED_CLOUDS[s.cloud];
  const title = `${s.title} (${cloud.short})`;
  const create = `Создать ${title}`;
  const columns = datastoreColumns<CatalogTableRow>(
    s.title,
    () => (
      <Typography variant="body2">{`${s.service} ${cloud.short}`}</Typography>
    ),
    'Сервис облака',
  );
  return (
    <TypedCatalogPage
      section={s.cloud}
      title={title}
      subtitle={`${s.title} — managed-сервис ${s.service} ${cloud.title} в сети кластеров платформы`}
      kind="resource"
      type={s.type}
      columns={columns}
      create={{ title: create, to: s.template }}
      support={`Создаётся шаблоном «${title}» в кластере ${cloud.title}: описание — в viva/clusters (${s.cloud}/<кластер>/datastores/${s.kind}-<имя>), сервис создаёт пайплайн кластера, пароли пользователей — секреты <имя>-user-<пользователь> в кластере.`}
      emptyContent={
        <EmptyState
          missing="data"
          title={`${title}: пока ничего нет`}
          description={`Нужен Kubernetes-кластер в ${cloud.title}; запись появится здесь после регистрации в каталоге.`}
          action={
            <Button variant="contained" color="primary" href={s.template}>
              {create}
            </Button>
          }
        />
      }
    />
  );
};

/** Страница managed-сервиса облака (/cloudru/<kind>, /vkcloud/<kind>). */
export const ManagedServicePage = ({ service }: { service: ManagedService }) =>
  MANAGED_CLOUDS[service.cloud].enabled(useApi(configApiRef)) ? (
    <ManagedServiceList service={service} />
  ) : (
    <CloudDisabled service={service} />
  );
